import { Avatar, Box, Icon, Paper, Stack, Typography } from "@mui/material"
import { slickSettings } from "../../../../utils/helper"
import Icons from "../../../../assets/js/Icons"
import Slider from "react-slick"
import { useRef } from "react"

function Testimonials() {
  const setting = {
    ...slickSettings,
    speed: 5000,
    autoplay: true,
    slidesToShow: 1,
    autoplaySpeed: 3000,
  }

  const slickRef = useRef("")

  return (
    <Slider {...setting} ref={slickRef}>
      {new Array(2).fill()?.map((_, i) => (
        <Box key={i} px={2}>
          <Paper sx={{ p: "30px" }}>
            <Box sx={{ borderBottom: "1px solid #dfdfdf" }}>
              <Stack
                spacing={1}
                direction="row"
              >
                {new Array(5).fill().map((_, i) => (
                  <Icon
                    key={i}
                    sx={{
                      color: i < 4 ? "#e5b216" : "#d6d6d6"
                    }}
                  >
                    <Icons.Star />
                  </Icon>
                ))
                }
              </Stack>
              <Typography
                sx={{
                  py: "30px",
                  color: "#484f56",
                  fontWeight: "500",
                  lineHeight: "28px",
                }}
              >Lorem, ipsum dolor sit amet consectetur adipisicing elit. Consequuntur incidunt, dolores ea voluptas pariatur doloribus mollitia architecto necessitatibus quasi fuga? Id eius aut excepturi. A est aut eligendi et perferendis eveniet, quasi dicta consequatur aperiam similique non, veritatis officiis quo.
              </Typography>
            </Box>
            <Box
              sx={{
                gap: 2,
                mt: "30px",
                display: "flex",
                alignItems: "center"
              }}
            >
              <Avatar
                sx={{
                  width: { xs: "45px", lg: "60px" },
                  height: { xs: "45px", lg: "60px" },
                }}
              />
              <Box>
                <Typography
                  sx={{
                    color: "other.color1",
                    fontWeight: "700",
                    lineHeight: "1",
                    fontSize: { xs: "18px", lg: "20px" },
                  }}
                >James Dokidis
                </Typography>
                <Typography
                  sx={{
                    color: "#6c757d",
                    fontWeight: "500"
                  }}
                >Our customer
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Box>
      ))
      }
    </Slider>
  )
}

export default Testimonials